import styled from 'styled-components';

import { Button } from '../Button';
import { breakpoints, spacing } from '../../constants';

export const MobileButtonRow = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    ${Button} {
        padding: 0;
        width: 100%;

        &:first-child {
            margin-right: ${spacing.md};
        }
    }

    @media (${breakpoints.mediumMin}) {
        display: none;
    }
`;
